import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../../pages/home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const ventajas = [
  { icon: "ri-eye-off-line", title: "Discretas", desc: "Prácticamente invisibles cuando están enrolladas. No estropean la estética de tu ventana ni de tu fachada." },
  { icon: "ri-windy-line", title: "Resistentes a viento y lluvia", desc: "Tela reforzada con fibra de vidrio que aguanta golpes de viento sin romperse ni deshilacharse." },
  { icon: "ri-contrast-drop-line", title: "Sistema de freno suave", desc: "Se bajan y suben suavemente gracias al sistema de freno integrado. No rebotan ni golpean el marco." },
  { icon: "ri-stack-line", title: "Compatibles con persianas", desc: "Se instalan en el mismo hueco que la persiana, sin ocupar espacio adicional. Ideal para ventanas estándar." },
];

const tipos = [
  { emoji: "🪟", title: "Ventana", desc: "La más común. Se enrolla en un cassette integrado en la parte superior de la ventana. Fácil de usar cada día." },
  { emoji: "🚪", title: "Puerta", desc: "Para puertas de salida a terraza o jardín. Sistema de paso lateral con freno automático para que no se cierre sola." },
  { emoji: "↔️", title: "Lateral", desc: "Para cerrar laterales de pérgolas o porches. Se enrolla verticalmente y se fija al suelo con imanes o cremallera." },
];

const materiales = [
  { name: "Fibra de vidrio", desc: "La más resistente. No se oxida ni se deshilacha. Ideal para zonas costeras como Málaga.", tag: "Más popular" },
  { name: "Poliéster reforzado", desc: "Más económica y ligera. Buena opción para ventanas interiores o protección básica.", tag: "Económica" },
  { name: "Anti-polen", desc: "Malla más densa que bloquea polen, polvo fino y mosquitos pequeños. Perfecta para alérgicos.", tag: "Alérgicos" },
];

const colores = [
  { color: "bg-white border border-slate-200", name: "Blanco" },
  { color: "bg-[#8B5E3C]", name: "Marrón" },
  { color: "bg-[#6B7280]", name: "Gris" },
  { color: "bg-primary", name: "Lacado a medida" },
];

const faqs = [
  { q: "¿Se pueden usar con persianas enrollables?", a: "Sí, totalmente compatibles. Instalamos la mosquitera en el mismo vano de la persiana, una encima de la otra. No ocupan espacio adicional." },
  { q: "¿Cuánto duran las telas?", a: "La fibra de vidrio dura entre 7 y 10 años en condiciones normales. En zonas costeras con salitre recomendamos revisar cada 5 años." },
  { q: "¿Se pueden reparar si se rompen?", a: "Sí, cambiamos la tela sin tocar el marco. Es un trabajo rápido que hacemos en tu casa en menos de una hora." },
  { q: "¿Resisten a perros y gatos?", a: "Existen telas reforzadas anti-mascotas que aguantan arañazos. Te recomendamos esta opción si tienes animales en casa." },
  { q: "¿Hay opción de freno manual o automático?", a: "Ambas. El freno suave es estándar. También disponemos de sistema de recogida automática mediante muelle para puertas de uso frecuente." },
];

export default function MosquiterasEnrollables() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Mosquiteras Enrollables Málaga | Discretas y Resistentes"
        description="Mosquiteras enrollables en Málaga: discretas, resistentes a viento y lluvia. Compatibles con persianas. Presupuesto gratis. ☎ 951 12 07 70"
        canonical="/mosquiteras/mosquiteras-enrollables/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Mosquiteras", path: "/mosquiteras" }, { name: "Mosquiteras enrollables" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[55%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Las más prácticas
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Mosquiteras Enrollables en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  La solución más práctica: se enrollan cuando no las necesitas. Discretas y efectivas para cualquier ventana o puerta.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Desde 120€</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Instalación 1h</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[45%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200&q=80&auto=format&fit=crop"
                    alt="Mosquitera enrollable en Málaga"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* VENTAJAS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Ventajas de las enrollables</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {ventajas.map((v, i) => (
                <motion.div
                  key={v.title}
                  className="bg-white rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-12 h-12 bg-secondary/10 text-secondary rounded-xl flex items-center justify-center mb-5">
                    <i className={`${v.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{v.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{v.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* TIPOS DE INSTALACIÓN */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Tipos de instalación</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {tipos.map((t, i) => (
                <motion.div
                  key={t.title}
                  className="bg-surface-alt rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-4xl mb-4">{t.emoji}</div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-2">{t.title}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{t.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* MATERIALES */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Materiales disponibles</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {materiales.map((m, i) => (
                <motion.div
                  key={m.name}
                  className="bg-white rounded-[20px] p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="absolute top-0 right-0 bg-primary text-white font-body font-semibold text-xs px-3 py-1 rounded-bl-lg">
                    {m.tag}
                  </div>
                  <h3 className="font-heading font-bold text-xl text-text-primary mb-3 mt-2">{m.name}</h3>
                  <p className="font-body text-sm text-text-secondary leading-relaxed">{m.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* COLORES */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Colores de marco</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              <p className="font-body text-lg text-text-secondary mt-4 max-w-2xl mx-auto">
                Elegimos el color que mejor combine con tus ventanas y la fachada de tu edificio.
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-6">
              {colores.map((c) => (
                <div key={c.name} className="flex flex-col items-center gap-3">
                  <div className={`w-16 h-16 rounded-full shadow-md ${c.color}`}></div>
                  <span className="font-body font-medium text-sm text-text-primary">{c.name}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* PRECIO */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Precio orientativo</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="max-w-xl mx-auto bg-white rounded-3xl p-8 md:p-12 text-center shadow-sm">
              <div className="font-heading font-extrabold text-5xl md:text-6xl text-primary mb-2">120-250 €</div>
              <p className="font-body text-lg text-text-secondary mb-6">por ventana estándar</p>
              <div className="flex flex-col gap-3 text-left max-w-sm mx-auto">
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Marco de aluminio lacado</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Tela de fibra de vidrio</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Instalación incluida</div>
                <div className="flex items-center gap-2 font-body text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 2 años</div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Preguntas frecuentes</h2>
                <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              </div>
              <div className="space-y-4" itemScope itemType="https://schema.org/FAQPage">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6 md:p-8"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-text-primary py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-white mb-4">
              ¿Quieres una mosquitera enrollable a medida?
            </h2>
            <p className="font-body text-lg text-slate-300 mb-8 max-w-2xl mx-auto">
              Te visitamos gratis, medimos tus ventanas y te damos presupuesto sin compromiso.
            </p>
            <a
              href="tel:+34951120770"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors"
            >
              <span>📞</span> Llámanos: 951 12 07 70
            </a>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}